<template>

    <section class="hero is-fullheight">
      <!-- Hero head: will stick at the top -->
      <div class="hero-head">
      </div>

      <!-- Hero content: will be in the middle -->
      <div class="hero-body" id="particles-js">
        <div class="container">
          <a class="b-logo" href="https://bringe.com">
            <img src="../assets/logo.png" alt="Logo">
          </a>
          <h2 class="subtitle">
            <br>
            Die Dienste DNS-over-HTTPS (DoH) und DNS-over-TLS (DoT) werden derzeit experimentell angeboten und stehen ausschließlich Mitarbeitern und Kunden der Bringe Informationstechnik GmbH zur Verfügung. Dritten ist untersagt, diese Dienste zu nutzen.
            <br><br>
            Die Bringe Informationstechnik GmbH übernimmt keine Haftung bezüglich der Verfügbarkeit und Korrektheit der übermittelten Daten.
            <br><br>
            The services DNS-over-HTTPS (DoH) and DNS-over-TLS (DoT) are currently provided experimentally and are as such intended only for the clients and employees of Bringe Informationstechnik GmbH. All other parties are expressly forbidden from using these services.
            <br><br>
            Bringe Informationstechnik GmbH does not guarantee the availability and correctness of these service.
          </h2>
        </div>
      </div>


    </section>

</template>

<script>

export default {
  name: 'BDohDotPolicy',
}
</script>

<style lang="scss">
  @import "~bulma/sass/utilities/initial-variables";
  @import "~bulma/sass/utilities/functions";
  @import "../styles/variables";
  @import "~bulma";
  @import "~bulma-pricingtable";
  @import "../styles/globals";
  @import "../styles/mobile";
  @import "../styles/helpers";

  .b-logo {
    img {
      width: 10em;
    }

  }
</style>
